/**
 * Handoff to SI / tool login with sainfo prefill.
 */
export const goLogin = (ctx) => {
    if (!ctx.authCallback) {
        return 'Callback URL is missing'
    }

    const account = ctx.account || ctx.email
    const va = ctx.va || 'email'
    const apiPlatform = ctx.apiPlatform || ctx.platform

    const tinfo = ctx.tool
        ? [{ name: ctx.tool.name, tid: ctx.tool.tid, type: ctx.tool.type, logo: ctx.tool.logo }]
        : [{ name: 'Tool', tid: null, type: 1, logo: null }]

    const strg = {
        cb: ctx.authCallback,
        tid: ctx.tool?.tid ?? null,
        tinfo,
        expiration: '',
        platform: ctx.platformQuery || (apiPlatform === 'biz' ? 'business' : 'personal'),
        tsa_key: ctx.from,
        pricing: ctx.pricing,
        subcb: ctx.subcb,
        ref_a_frnd: ctx.ref_a_frnd,
    }

    localStorage.setItem('pm_tool_session', JSON.stringify(strg))

    const sainfo = {
        va,
        account: window.btoa(`unauth_${account}`),
    }

    const useToolLogin = typeof ctx.tool?.type === 'number' && ctx.tool.type !== 1
    const path = useToolLogin ? 'tool/login' : 'login'
    const params = new URLSearchParams()
    params.set('from', JSON.stringify(strg))
    params.set('sainfo', JSON.stringify(sainfo))

    window.location.href = `/${apiPlatform}/${path}?${params.toString()}`
    return null
}
